exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".FiltersCrumbs-9694444f{display:flex}.Crumb-9e199a50{flex:0 0 auto;padding-left:.5em;padding-right:.5em;margin-right:1em;border-radius:2px;background-color:#6982FF;color:#FAFAFA;font-size:12px;font-weight:500;cursor:pointer}.Crumb-9e199a50 .close-b65952a8{margin-left:.5em;font-weight:bold}\n", ""]);

// Exports
exports.locals = {
	"FiltersCrumbs": "FiltersCrumbs-9694444f",
	"Crumb": "Crumb-9e199a50",
	"close": "close-b65952a8"
};